import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { from, Observable, of } from 'rxjs';
import { map, catchError, mergeMap, switchMap } from 'rxjs/operators';
import {FinancialIncomeActionTypes,LoadFinancialIncome,LoadFinancialIncomeSuccess,LoadFinancialIncomesSuccess,LoadFinancialIncomeFailure,LoadFinancialIncomes,LoadFinancialIncomesFailure,UpdateFinancialIncome,UpdateFinancialIncomeFailure,UpdateFinancialIncomeSuccess,DeleteFinancialIncome,DeleteFinancialIncomeFailure,DeleteFinancialIncomeSuccess} from '../actions/financial-income.actions';
import { FinancialIncomeService } from '../../services/financial-income.service';
import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';

import { SummaryFinancialIncomeListModel, SummaryFinancialIncomeModel } from '../../models/summary-financial-income.model';


@Injectable()
export class FinancialIncomeEffects {
  constructor(
    private actions$: Actions,
    private service: FinancialIncomeService
  ) { }

  /** 🔹 Get All */

  
  loadFinancialIncomes$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(FinancialIncomeActionTypes.LoadFinancialIncomes),
    switchMap((action: LoadFinancialIncomes) =>
      this.service.getBySearch(action.payload.filter).pipe(
        map((res: PaginableResponseModel<SummaryFinancialIncomeModel> & { summary: SummaryFinancialIncomeListModel }) => {
          if (!res || !res.isSuccess) {
              return new LoadFinancialIncomesFailure({ error: 'No se pudo cargar la lista' });
            }
            return new LoadFinancialIncomesSuccess({
              items: res.values,
              total: res.total,
              summary: res.summary
            });
          }),
          catchError(error => of(new LoadFinancialIncomesFailure({ error })))
        )
      )
    ));


      /** 🔹 Get By Id */
      
      loadFinancialIncomeById$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(FinancialIncomeActionTypes.LoadFinancialIncome),
        mergeMap((action: LoadFinancialIncome) =>
          this.service.getById(action.payload.uid).pipe(
            map(response => new LoadFinancialIncomeSuccess(response)),
            catchError(error => of(new LoadFinancialIncomeFailure({ error })))
          )
        )
      ));

       /** 🔹 Update */
        
        updateFinancialIncome$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(FinancialIncomeActionTypes.UpdateFinancialIncome),
          mergeMap((action: UpdateFinancialIncome) =>
            this.service.update(action.payload.financialIncome).pipe(
              switchMap(updated => [
                new UpdateFinancialIncomeSuccess({ financialIncome: updated }),
              ]),
              catchError(error => of(new UpdateFinancialIncomeFailure({ error })))
            )
          )
        ));

        /** 🔹 Delete */
        
        deleteFinancialIncome$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(FinancialIncomeActionTypes.DeleteFinancialIncome),
          mergeMap((action: DeleteFinancialIncome) =>
            this.service.delete(action.payload.uid).pipe(
              switchMap(() => [
                new DeleteFinancialIncomeSuccess({ uid: action.payload.uid }),
              ]),
              catchError(error => of(new DeleteFinancialIncomeFailure({ error })))
            )
          )
        ));


}
